import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "content-information" }
const _hoisted_2 = { class: "content-title" }
const _hoisted_3 = {
  key: 0,
  class: "separate-text"
}
const _hoisted_4 = {
  key: 1,
  class: "separate-text"
}
const _hoisted_5 = {
  key: 2,
  class: "content-subtitle"
}
const _hoisted_6 = {
  key: 3,
  class: "content-subtitle"
}
const _hoisted_7 = { class: "content-details" }
const _hoisted_8 = { class: "features" }
const _hoisted_9 = { class: "feature-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.isDesktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("h2", { class: "title" }, "Project Sales &", -1),
            _createElementVNode("h2", { class: "title" }, "Marketing", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("h2", { class: "title" }, "Project Sales & Marketing", -1)
          ]))])),
      _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "pay" }, "Pay per lot", -1)),
      ($setup.isDesktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("p", { class: "subtitle" }, "You focus on developing.", -1),
            _createElementVNode("p", { class: "subtitle" }, "We’ll take care of the", -1),
            _createElementVNode("p", { class: "subtitle" }, "sales.", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("p", { class: "subtitle" }, "You focus on developing. We’ll take care of the sales.", -1)
          ]))])),
      _createVNode($setup["ContactUsLink"], {
        class: "request",
        animationName: "''",
        toContactUsForm: false,
        text: 'Book a call',
        isButtonCallBackModal: true,
        linkCalendly: $setup.CALENDLY_PROJECT_SALES_MARKETING_LINK
      }, null, 8, ["linkCalendly"])
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "line" }, null, -1)),
    _createElementVNode("div", _hoisted_7, [
      _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "title" }, "Sell your land faster. Save on agent fees.", -1)),
      _createElementVNode("ul", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.features, (feature) => {
          return (_openBlock(), _createElementBlock("li", { key: feature }, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "content-checkmark" }, [
              _createElementVNode("div", { class: "checkmark" })
            ], -1)),
            _createElementVNode("span", _hoisted_9, _toDisplayString(feature), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}